import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocationSpecificationFormState } from '../../reducers/location-specification.reducer';
import { CmxHttpClient } from '@cemex/cmx-client-layout';
import { IMyProductRequest, IPatchOrderRequestedResponse } from '../../models/order-management/product.model';
import { getTopProductState } from '../../selectors';
import { SelectOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-i';
import { Order, TopProductsResp } from '@cemex-core/cmx-api';
import { IOrderItemResponse } from '../../models/order-management/orderItem.model';
import { IOrderDraft } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/order-request.model';
import { getOrderSelectedDetail } from '@ordersnproducts/modules/new-repeat-order/selectors/order-selected-detail.selector';



@Injectable()
export class ProductLoaderService implements SelectOptionLoaderI {
  constructor(
    private store$: Store<LocationSpecificationFormState>,
    private http: CmxHttpClient,
  ) {}

  patchOrdersRequested(groupId: number): Observable<IPatchOrderRequestedResponse> {
    return this.http.patch<{
      PatchOrderRequestedResponse;
    }>(
      `v1/odm/orders/group/${groupId}/requested`,
      {},
      {
        headers: {
          NO_RETRY: 'NO_RETRY',
        },
      },
    ) as unknown as Observable<IPatchOrderRequestedResponse>;
  }

  /* TO DO: get this APIS and models to the cemex library */

  public getMyProductsV3(request: IMyProductRequest): Observable<TopProductsResp> {
    const endpoint = `v3/mm/myproducts?`;
    let requestParams = '';

    if (request.productId) {
      requestParams += `productId=${request.productId.toString()}`;
    }

    if (request.salesDocumentTypeId) {
      requestParams += `&salesDocumentTypeId=${request.salesDocumentTypeId.toString()}`;
    }

    if (request.salesDocumentTypeCode) {
      requestParams += `&salesDocumentTypeCode=${request.salesDocumentTypeCode.toString()}`;
    }

    if (request.productLineId) {
      requestParams += `&productLineId=${request.productLineId.toString()}`;
    }

    if (request.salesAreaId) {
      requestParams += `&salesAreaId=${request.salesAreaId.toString()}`;
    }

    if (request.shippingConditionId) {
      requestParams += `&shippingConditionId=${request.shippingConditionId.toString()}`;
    }

    if (request.jobsiteId) {
      requestParams += `&shipmentLocationId=${request.jobsiteId.toString()}`;
    }
    return this.http.get<any>(endpoint + requestParams);
  }

  public getOrderItems(orderId: number): Observable<IOrderItemResponse> {
    const endpoint = `/v1/odm/orders/${orderId}/items`;
    return this.http.get<IOrderItemResponse>(endpoint);
  }

  public getOrderDraft(request: IOrderDraft): Observable<any> {
    const endpoint = '/v1/odm/orders';
    return this.http.post(endpoint, request);
  }

  public getOrder(orderId: number): Observable<Order> {
    const endpoint = `/v1/odm/orders/${orderId}`;
    return this.http.get(endpoint);
  }

  public UpdateOrderDraft(orderId: number, request: IOrderDraft): Observable<any> {
    const endpoint = `/v1/odm/orders/${orderId}/`;
    return this.http.put(endpoint, request);
  }

  loadOptions(): Observable<SelectOptionI[]> {
    return combineLatest([this.store$.select(getTopProductState), this.store$.select(getOrderSelectedDetail)]).pipe(
      map(([products, order]: [any, Order]) => {
        const newOrder = _safe(() => order['orders'][0]);
        if (
          newOrder &&
          !products.topProducts.find((product) => product.productId === order.items[0].product.productId)
        ) {
          products.topProducts.push({
            productId: newOrder.orderProducts[0].productId,
            productCode: newOrder.orderProducts[0].productCode,
            productDesc: newOrder.orderProducts[0].productDesc,
          });
        }

        return products.topProducts
          .map((product) => {
            return {
              id: product.productId,
              name: `${product.productCode.replace(/0+/, '')} ${product.productDesc}`,
            };
          })
          .filter((value, index, self) => {
            return self.findIndex((i) => i.id === value.id) === index;
          });
      }),
    );
  }
}
